import React from 'react';

const PayRuns = () => {
  return (
    <div className="container-fluid">
      <div className="d-flex justify-content-center align-items-center mb-4">
        <div>
          <h1 className="h3 mb-0">Pay Runs</h1>
          <p className="text-muted">Process and manage payroll runs.</p>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Payroll Processing</h5>
              <p className="card-text">Pay runs content will be displayed here.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayRuns;